import {
    type BrowserOptions,
    browserTracingIntegration,
    init,
    makeBrowserOfflineTransport,
    makeFetchTransport,
    reportingObserverIntegration,
} from '@sentry/angular';

export const initSentryBrowser = (sentryConfig: {
    denyUrls?: RegExp[];
    dsn?: string;
    environment?: string;
    tracesSampleRate?: number;
    tracePropagationTargets?: string[];
}): void => {
    const { dsn, environment, tracePropagationTargets, tracesSampleRate, denyUrls } = sentryConfig;

    if (!dsn || dsn === '' || !environment || environment === '') {
        return;
    }

    const integrations: BrowserOptions['integrations'] = [reportingObserverIntegration()];

    if (Array.isArray(tracePropagationTargets) && tracePropagationTargets.length > 0) {
        integrations.push(browserTracingIntegration());
    }

    const initConfig: BrowserOptions = {
        denyUrls: denyUrls ?? [],
        dsn,
        environment,
        integrations,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate,
        tracePropagationTargets,
        transport: makeBrowserOfflineTransport(makeFetchTransport),
    }

    init(initConfig);
}
